module.exports = __webpack_public_path__ + "img/w46b.e3250cc7.jpg";